import { render } from "./UiTappable.vue?vue&type=template&id=959b5466&ts=true"
import script from "./UiTappable.vue?vue&type=script&lang=ts"
export * from "./UiTappable.vue?vue&type=script&lang=ts"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__